import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", null, [
    _createElementVNode("tr", null, [
      _cache[0] || (_cache[0] = _createElementVNode("td", null, [
        _createElementVNode("span")
      ], -1)),
      _createElementVNode("td", null, [
        _createElementVNode("span", null, _toDisplayString(_ctx.timeRemainingString), 1)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("td", null, [
        _createElementVNode("span")
      ], -1))
    ]),
    (_ctx.verbose)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
          _createElementVNode("td", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.team1TotalAlgos), 1)
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("td", null, [
            _createElementVNode("span", null, "Total Vote")
          ], -1)),
          _createElementVNode("td", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.team2TotalAlgos), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.verbose)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
          _createElementVNode("td", null, [
            _createElementVNode("span", null, "1:" + _toDisplayString(_ctx.team1Ratio), 1)
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("td", null, [
            _createElementVNode("span", null, "Return Ratio")
          ], -1)),
          _createElementVNode("td", null, [
            _createElementVNode("span", null, "1:" + _toDisplayString(_ctx.team2Ratio), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}